"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = AppMenu;
var _react = _interopRequireDefault(require("react"));
var _Button = _interopRequireDefault(require("@material-ui/core/Button"));
var _Menu = _interopRequireDefault(require("@material-ui/core/Menu"));
var _MenuItem = _interopRequireDefault(require("@material-ui/core/MenuItem"));
var _menuBars = _interopRequireDefault(require("../../assets/images/menu-bars.svg"));
// @ts-ignore

function AppMenu() {
  const [anchorEl, setAnchorEl] = _react["default"].useState(null);
  function handleClick(event) {
    setAnchorEl(event.currentTarget);
  }
  function handleClose() {
    setAnchorEl(null);
  }
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    "aria-controls": "simple-menu",
    "aria-haspopup": "true",
    onClick: handleClick
  }, /*#__PURE__*/_react["default"].createElement("img", {
    src: _menuBars["default"],
    alt: ""
  })), /*#__PURE__*/_react["default"].createElement(_Menu["default"], {
    id: "simple-menu",
    anchorEl: anchorEl,
    keepMounted: true,
    open: Boolean(anchorEl),
    onClose: handleClose
  }, /*#__PURE__*/_react["default"].createElement(_MenuItem["default"], {
    onClick: handleClose
  }, "epianalyst"), /*#__PURE__*/_react["default"].createElement(_MenuItem["default"], {
    onClick: handleClose
  }, "epiencounter"), /*#__PURE__*/_react["default"].createElement(_MenuItem["default"], {
    onClick: handleClose
  }, "epiconnect")));
}